// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.rechargeModal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  z-index: 12;
}
.rechargeModal .Content {
  display: flex;
  flex-direction: column;
  border-radius: 0.75rem;
  align-items: flex-start;
  background: var(--Foreground);
  width: 32rem;
  color: var(--TextColor);
  overflow: hidden;
}
.rechargeModal .Content .HeaderClose {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  height: 3rem;
  background-color: var(--AccentColor);
  padding: 1.5rem;
}
.rechargeModal .Content .HeaderClose .ModalHeader {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--Foreground);
}
.rechargeModal .Content .HeaderClose svg {
  cursor: pointer;
}
.rechargeModal .Content .HeaderClose svg path {
  fill: var(--Foreground);
}
.rechargeModal .Content .HeaderClose svg:hover {
  transform: rotate(90deg);
  transition: all 0.3s ease;
}
.rechargeModal .Content .contentContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1.5rem 0.5rem;
  gap: 1.2rem;
}
.rechargeModal .Content .contentContainer .currentBalance {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  border: 1px solid #cccad4;
  border-radius: 6px;
  padding: 0.5rem 1rem;
}
.rechargeModal .Content .contentContainer .rechargeInputForm {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.rechargeModal .Content .contentContainer .rechargeInputForm .rechargeInputContainer {
  position: relative;
  height: 1.8rem;
  width: 100%;
  padding: 0 1.5rem;
}
.rechargeModal .Content .contentContainer .rechargeInputForm .rechargeInputContainer::after {
  content: "₹";
  position: absolute;
  top: 0;
  left: 1.8rem;
  top: 50%;
  transform: translateY(-12px);
}
.rechargeModal .Content .contentContainer .rechargeInputForm .rechargeInputContainer .rechargeInput {
  width: inherit;
  height: 1.8rem;
  padding: 0.5rem 1rem 0.5rem 1.2rem;
  background: none;
  border: none;
  border-radius: none;
  position: relative;
  color: var(--TextColor);
  font-size: inherit;
  border-bottom: 0.0625rem solid #9b9b9b;
}
.rechargeModal .Content .contentContainer .confirmBtn {
  padding: 0.5rem 1.5rem;
  background-color: var(--AccentColor);
  color: #ffffff;
  border-radius: 0.5rem;
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Topbar/RechargeModal.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,0BAAA;EACA,WAAA;AAEF;AADE;EACE,aAAA;EACA,sBAAA;EAEA,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;EAEA,uBAAA;EACA,gBAAA;AACJ;AAAI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;AAEN;AAAM;EACE,iBAAA;EACA,gBAAA;EACA,wBAAA;AAER;AAAM;EACE,eAAA;AAER;AADQ;EACE,uBAAA;AAGV;AAAM;EACE,wBAAA;EACA,yBAAA;AAER;AACI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;AACN;AAAM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EAEA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AACR;AACM;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACR;AAAQ;EACE,kBAAA;EAEA,cAAA;EACA,WAAA;EACA,iBAAA;AACV;AACU;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,QAAA;EACA,4BAAA;AACZ;AACU;EACE,cAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;AACZ;AAGM;EACE,sBAAA;EACA,oCAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AADR","sourcesContent":[".rechargeModal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #000000b3;\n  backdrop-filter: blur(3px);\n  z-index: 12;\n  .Content {\n    display: flex;\n    flex-direction: column;\n    // padding: 1rem 1.5rem 1.5rem 1.5rem;\n    border-radius: 0.75rem;\n    align-items: flex-start;\n    background: var(--Foreground);\n    width: 32rem;\n    // min-height: 20rem;\n    color: var(--TextColor);\n    overflow: hidden;\n    .HeaderClose {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 1rem;\n      height: 3rem;\n      background-color: var(--AccentColor);\n      padding: 1.5rem;\n      //   border-radius: 0.75rem 0.75rem 0 0;\n      .ModalHeader {\n        font-size: 1.2rem;\n        font-weight: 700;\n        color: var(--Foreground);\n      }\n      svg {\n        cursor: pointer;\n        path {\n          fill: var(--Foreground);\n        }\n      }\n      svg:hover {\n        transform: rotate(90deg);\n        transition: all 0.3s ease;\n      }\n    }\n    .contentContainer {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      padding: 1.5rem 0.5rem;\n      gap: 1.2rem;\n      .currentBalance {\n        display: flex;\n        justify-content: space-between;\n        gap: 1rem;\n        // font-size: 1.2em;\n        width: 100%;\n        border: 1px solid #cccad4;\n        border-radius: 6px;\n        padding: 0.5rem 1rem;\n      }\n      .rechargeInputForm {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.5rem;\n        .rechargeInputContainer {\n          position: relative;\n          // font-size: 1.2rem;\n          height: 1.8rem;\n          width: 100%;\n          padding: 0 1.5rem;\n          // margin: 1rem 0;\n          &::after {\n            content: \"₹\";\n            position: absolute;\n            top: 0;\n            left: 1.8rem;\n            top: 50%;\n            transform: translateY(-12px);\n          }\n          .rechargeInput {\n            width: inherit;\n            height: 1.8rem;\n            padding: 0.5rem 1rem 0.5rem 1.2rem;\n            background: none;\n            border: none;\n            border-radius: none;\n            position: relative;\n            color: var(--TextColor);\n            font-size: inherit;\n            border-bottom: 0.0625rem solid #9b9b9b;\n          }\n        }\n      }\n      .confirmBtn {\n        padding: 0.5rem 1.5rem;\n        background-color: var(--AccentColor);\n        color: #ffffff;\n        border-radius: 0.5rem;\n        margin-top: 0.5rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
